import Moment from 'moment';
import React, { useEffect, useReducer } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../../common/services/subscription/Actions';
import * as SubscriptionService from '../../../../common/services/subscription/Service';

import { useTranslation } from 'react-i18next';
import cssMessages from '../../../assets/scss/Messages.scss';
import { RootState } from '../../../base/RootReducer';
import { config } from '../../../common/';
import { AppThunkDispatch } from '../../../common/types';
import css from './ShowDetails.scss';

import classNames from 'classnames';
import Notifications from 'react-notification-system-redux';
import { Link } from 'react-router-dom';
import { SubscriptionError } from '../../../../common/services/subscription/Types';
import { ChargebeePlanDTO } from '../../../../common/types/dto/ChargebeePlanDTO';
import { ChargebeeSubscriptionDTO } from '../../../../common/types/dto/ChargebeeSubscriptionDTO';
import { CustomerDataDTO } from '../../../../common/types/dto/CustomerDataDTO';
import { SubscriptionItemDTO } from '../../../../common/types/dto/SubscriptionItemDTO';
import { useHistory, useMatch } from '../../../common/RouterHooks';
import TopNav from '../../../main/components/TopNav';

import DOMPurify from 'dompurify';
import DisplayLoading from '../../../../common/components/misc/DisplayLoading';
// import CreateForm from '../CreateForm';
import { SubscrStatusEnum } from '../Types';
import AccordionAvailableServices from './AccordionAvailableServices/AccordionAvailableServices';
import CarHistory, { HistoryItem } from './CarHistory/CarHistory';
import Modal from './Modal/ModalShowDetails';

interface ShowDetailsState {
    getActivePlans: ChargebeePlanDTO[] | undefined;
    getSubscriptionItems: SubscriptionItemDTO[] | undefined;
    getUserSubscriptions: ChargebeeSubscriptionDTO[] | undefined;
    vehcode: number;
    submitErrorText: string;
    isOpen: boolean;
    isLoading: boolean;
    // isPriceNotSet: boolean;
}

export interface RouterShowDetailsProps {
    planId: string;
    vehcode: string;
}

export interface ShowDetailsStateProps {
    vehcode: number;
}

interface ReduxStateProps {
    getActivePlans: ChargebeePlanDTO[];
    isCommunicatingGetActivePlans: boolean;
    getSubscriptionItems: SubscriptionItemDTO[];
    isCommunicatingGetSubscriptionItems: boolean;
    getUserSubscriptions: ChargebeeSubscriptionDTO[];
    isCommunicatingGetUserSubscriptions: boolean;
    updatePaymentSource: boolean;
    isCommunicatingUpdatePaymentSource: boolean;
    cancelSubscription: ChargebeeSubscriptionDTO;
    isCommunicatingCancelSubscription: boolean;
    customerInfo: CustomerDataDTO | undefined;
    dispatch: AppThunkDispatch;
}

interface ReduxDispatchProps {
    subscriptionActions: typeof Actions;
    subscriptionServiceActions: SubscriptionService.ServiceActions;
}

type ShowDetailsProperties =
    ReduxStateProps
    & ReduxDispatchProps
    & ShowDetailsStateProps;

const ShowDetails: React.FC<ShowDetailsProperties> = (Props) => {
    const initialState: ShowDetailsState = {
        getActivePlans: undefined,
        getSubscriptionItems: undefined,
        getUserSubscriptions: undefined,
        vehcode: -1,
        submitErrorText: '',
        isOpen: false,
        isLoading: false,
        // isPriceNotSet: true,
    };
    const [state, setState]: [ShowDetailsState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );
    const { t } = useTranslation();
    const routeMatch = useMatch<RouterShowDetailsProps>();
    const history = useHistory();

    useEffect(() => {
        if (!state.getActivePlans && !state.getSubscriptionItems && !state.getUserSubscriptions) {
            setState({
                getActivePlans: [],
                getSubscriptionItems: [],
                getUserSubscriptions: [],
            });
        } else {
            if (Number(routeMatch.params.vehcode) === state.vehcode) {
                return;
            }
            setState({
                vehcode: Number(routeMatch.params.vehcode),
                getActivePlans: undefined,
                getSubscriptionItems: undefined,
                getUserSubscriptions: undefined,
                submitErrorText: '',
            });

            try {
                Props.subscriptionServiceActions.getSubscriptionItems();
                Props.subscriptionServiceActions.getActivePlans();
                Props.subscriptionServiceActions.getUserSubscriptions();
            } catch (error) {
                let exceptionErrorMsg: string = t('exception:UnknownException');
                if (error instanceof SubscriptionError) {
                    const exceptionType: string = error.subscriptionErrorInfo.exceptionType || 'UnknownException';
                    exceptionErrorMsg = t(`exception:${exceptionType.split('.').pop()}`);
                }
                setState({
                    submitErrorText: exceptionErrorMsg,
                    getActivePlans: [],
                    getSubscriptionItems: [],
                    getUserSubscriptions: [],
                });
                Props.dispatch(Notifications.error({
                    title: t('error'),
                    message: exceptionErrorMsg,
                    position: 'tc',
                    autoDismiss: 5,
                }));
            }
        }
    });

    useEffect(() => {
        if (Props.getActivePlans) {
            setState({ getActivePlans: Props.getActivePlans });
        }
    }, [Props.getActivePlans]);

    useEffect(() => {
        if (Props.getSubscriptionItems) {
            setState({ getSubscriptionItems: Props.getSubscriptionItems });
        }
    }, [Props.getSubscriptionItems]);

    useEffect(() => {
        if (Props.getUserSubscriptions) {
            setState({ getUserSubscriptions: Props.getUserSubscriptions });
        }
    }, [Props.getUserSubscriptions]);

    const plan = state.getActivePlans ? state.getActivePlans.find((x) => x.id === routeMatch.params.planId) : null;

    // const yearlyPlan = plan && plan.plans && plan.plans.find((x) => x.periodUnit === PeriodUnitEnum.Year);
    // const monthlyPlan = plan && plan.plans && plan.plans.find((x) => x.periodUnit === PeriodUnitEnum.Month);

    const vehicle = state.vehcode > -1 && Props.customerInfo && Props.customerInfo.vehicles && Props.customerInfo.vehicles.find((x) => x.vehcode === state.vehcode);
    // const segment = vehicle && vehicle.segm;
    // const segmentMarkTxt = segment && segment === 'A' ? config.SubscriptionSegmentA : config.SubscriptionSegmentB;

    // const yearlyPlan = segment && plan && plan.plans && plan.plans.find((x) => x.periodUnit === PeriodUnitEnum.Year && ((x.id && segmentMarkTxt && x.id.indexOf(segmentMarkTxt) > -1) || !segmentMarkTxt));
    // const monthlyPlan = segment && plan && plan.plans && plan.plans.find((x) => x.periodUnit === PeriodUnitEnum.Month && ((x.id && segmentMarkTxt && x.id.indexOf(segmentMarkTxt) > -1) || !segmentMarkTxt));

    // const isPriceSetNotBeingSet = !monthlyPlan || !yearlyPlan;
    // if (isPriceSetNotBeingSet !== state.isPriceNotSet) {
    //     setState({ isPriceNotSet: isPriceSetNotBeingSet });
    // }

    const userSubscription = Props.getUserSubscriptions && plan && Props.getUserSubscriptions.find((x) => (x.planId === plan.id) && x.vehcode === state.vehcode
        && x.status !== SubscrStatusEnum.Cancelled && x.status !== SubscrStatusEnum.Paused && x.status !== SubscrStatusEnum.UnKnown);
    const userSubscriptionActivePlan = userSubscription ? userSubscription : Props.getUserSubscriptions && Props.getUserSubscriptions.find((x) => x.vehcode === state.vehcode
        && x.status !== SubscrStatusEnum.Cancelled && x.status !== SubscrStatusEnum.Paused && x.status !== SubscrStatusEnum.UnKnown);
    const vehicleHasActivePlan = userSubscriptionActivePlan != null;
    const currentTermEndStr = userSubscriptionActivePlan && userSubscriptionActivePlan.currentTermEnd ? Moment(userSubscriptionActivePlan.currentTermEnd).format('DD/MM/YYYY HH:mm:ss') : '';
    const isActivePlan = userSubscription != null;
    // const isYearlyPlan = null; // userSubscription && yearlyPlan && userSubscription.planId === yearlyPlan.id;
    const isOtherPlanActive = vehicleHasActivePlan && !isActivePlan;

    const isDevMode = config.AppEnv.indexOf('development') >= 0;
    const invalidParams = (Props.customerInfo && !vehicle);
    const historyItems = userSubscription && userSubscription.usages && userSubscription.usages.map(
        (x): HistoryItem => {
            const subscItem = Props.getSubscriptionItems.find((y) => y.code === x.subscriptionItemCode);
            return {
                name: x.name ? x.name : '',
                date: x.usageDate ? x.usageDate : new Date(),
                plafondUsedAmount: subscItem && subscItem.hasPlafond ? x.plafondConsumedAmount : 0,
            };
        },
    );

    function handleOpenModal() {
        setState({ isOpen: true });
    }
    function handleCloseModal() {
        setState({ isOpen: false });
    }
    function handleComfirmModal(reasonCode: number, reasonText: string) {
        setState({ isOpen: false });
        if (plan && userSubscription) {
            CancelSubscription(userSubscription.subscriptionId, reasonCode, reasonText);
        }
    }

    async function UpdatePaymentSource() {
        history.push(`${config.BaseURL}/subscription/updatepaymentsource`);
    }

    async function CancelSubscription(subscriptionId: string | null | undefined, reasonCode: number, reasonText: string) {
        if (!subscriptionId) {
            return;
        }
        const model: ChargebeeSubscriptionDTO = {
            subscriptionId,
            status: SubscrStatusEnum.Cancelled,
            vehcode: state.vehcode,
            isDue: false,  // Makes no sense but lint forces this; maybe split ChargebeeCreateSubscriptionDTO into multiple models for each purpose
            hasScheduledChanges: false, // same as above...
            reasonCode,
            reasonText,
        };
        try {
            setState({ isLoading: true });
            const cancelResult = await Props.subscriptionServiceActions.cancelSubscription(model);
            if (!cancelResult) {
                throw new Error('result is Null');
            }
            setState({ isLoading: false });
            history.push(`${config.BaseURL}/subscription/cancelconfirm/${plan && plan.name}/${state.vehcode}`);
        } catch (error) {
            let exceptionErrorMsg: string = t('exception:UnknownException');
            if (error instanceof SubscriptionError) {
                const exceptionType: string = error.subscriptionErrorInfo.exceptionType || 'UnknownException';
                exceptionErrorMsg = t(`exception:${exceptionType.split('.').pop()}`);
            }
            setState({
                submitErrorText: exceptionErrorMsg,
                isLoading: false,
            });
            Props.dispatch(Notifications.error({
                title: t('error'),
                message: exceptionErrorMsg,
                position: 'tc',
                autoDismiss: 5,
            }));
        }
    }

    function getModalItems(gPlan: ChargebeePlanDTO): string[] {
        const filteredResult = Props.getSubscriptionItems && Props.getSubscriptionItems.filter((subsc: SubscriptionItemDTO) => gPlan.availableServices && gPlan.availableServices.indexOf(subsc.code) >= 0 && subsc.name);
        return filteredResult.flatMap((x) => x.name ? x.name : ''); // this makes no sense but without it lint will not run. x.name is already filtered above...
    }

    const prettyPlate = vehicle && vehicle.licensePlate && vehicle.licensePlate.length === 6 ? (vehicle.licensePlate.match(/.{1,2}/g) || []).join('-') : '';
    return (
        <React.Fragment>
            <TopNav
                items={[
                    {
                        to: `${config.BaseURL}`,
                        label: t('breadcrumbs.menu'),
                    },
                    {
                        to: `${config.BaseURL}/subscription/packs`,
                        label: t('breadcrumbs.subscription'),
                    },
                    {
                        to: '#',
                        label: `${t('subscriptions:subscription')} ${plan ? plan.name : ''}`,
                    },
                ]}
            />
            <div className={classNames(['grid-x', 'grid-margin-x', 'my-bmw-servicos-value-service-subscricao'])}>
                <div className={classNames(['cell', 'small-12'])}>
                    <span className={'subscricao-titulo'}>{`${plan ? plan.name : ''}`}</span>
                </div>

                {<DisplayLoading validation={(!invalidParams && !plan) || Props.isCommunicatingGetUserSubscriptions || state.isLoading} />}
                {!isDevMode && invalidParams && <div>
                    <div id="not-found-section" className={css.notFoundContainer}>
                        <h1>{t('subscriptions:error.title')}</h1>
                        <svg fill="#FFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#000000" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M12,14C13.75,14 15.29,14.72 16.19,15.81L14.77,17.23C14.32,16.5 13.25,16 12,16C10.75,16 9.68,16.5 9.23,17.23L7.81,15.81C8.71,14.72 10.25,14 12,14Z" />
                        </svg>
                        <p>{t('subscriptions:error.msg').replace('%subName%', plan && plan.name ? plan.name : '').replace('%plate%', prettyPlate)}</p>
                        <p>{t('common:pageNotFound.linkMsgPart1')} <Link to={`${config.BaseURL}`}>{t('common:pageNotFound.linkMsgPart2')}</Link></p>
                    </div>
                </div>}

                {!state.isLoading && (isDevMode || !invalidParams) && plan && !Props.isCommunicatingGetUserSubscriptions && <React.Fragment>
                    <div className={classNames(['cell', 'large-7', 'small-12'])}>
                        <div className={classNames(['grid-x', 'subscricao-tabela-descricao'])}>

                            {vehicleHasActivePlan && userSubscriptionActivePlan && userSubscriptionActivePlan.isDue && <div className={cssMessages.warningMsg} >
                                <i className="fa fa-info-circle" style={{ marginRight: '5px' }} />
                                <b>{t('subscriptions:isDueMessage')}</b>
                            </div>}
                            {vehicleHasActivePlan && userSubscriptionActivePlan && userSubscriptionActivePlan.hasScheduledChanges && <div className={cssMessages.warningMsg} >
                                <i className="fa fa-info-circle" style={{ marginRight: '5px' }} />
                                <b>{`${t('subscriptions:pendingChanges')}${currentTermEndStr}`}</b>
                            </div>}
                            {vehicleHasActivePlan && userSubscriptionActivePlan && userSubscriptionActivePlan.status === SubscrStatusEnum.NonRenewing && <div className={cssMessages.warningMsg} >
                                <i className="fa fa-info-circle" style={{ marginRight: '5px' }} />
                                <b>{`${t('subscriptions:isNonRenewing')}${currentTermEndStr}`}</b>
                            </div>}

                            <div className={classNames(['cell', 'small-12'])}>
                                <h3 className={'sub-details-tw-1'}>{t('subscriptions:subDescription')}</h3>

                                <p dangerouslySetInnerHTML={{ __html: plan.description ? DOMPurify.sanitize(plan.description, { ADD_ATTR: ['target'] }) : '' }} className={'sub-details-tw-3'} />
                                <hr className={'sub-details-tw-1'} />
                            </div>
                            <div className={classNames(['cell', 'small-12'])}>
                                <h3 className={'adesao-da-subscricao'}>{t('subscriptions:createformUserHeader')}</h3>
                            </div>
                            <div className={classNames(['cell', 'small-6', 'adesao-subscricao-dados-esquerda'])}>
                                <label htmlFor="lbl-nome">{t('signup:formFields.firstNameSimple')}:</label>
                                <label>{Props.customerInfo ? Props.customerInfo.firstName : '-'}</label>
                            </div>
                            <div className={classNames(['cell', 'small-6', 'adesao-subscricao-dados-direita'])}>
                                <label htmlFor="lbl-apelido">{t('signup:formFields.lastName')}:</label>
                                <label>{Props.customerInfo ? Props.customerInfo.lastName : '-'}</label>
                            </div>
                            <div className={classNames(['cell', 'small-12', 'adesao-subscricao-dados-esquerda'])}>
                                <label htmlFor="lbl-morada">{t('signup:formFields.address')}:</label>
                                <label>{Props.customerInfo ? Props.customerInfo.address : '-'}</label>
                            </div>
                            <div className={classNames(['cell', 'small-6', 'adesao-subscricao-dados-esquerda'])}>
                                <label htmlFor="lbl-lote">{t('signup:formFields.addressNumber')}:</label>
                                <label>{Props.customerInfo ? Props.customerInfo.addressNumber : '-'}</label>
                            </div>
                            <div className={classNames(['cell', 'small-6', 'adesao-subscricao-dados-direita'])}>
                                <label htmlFor="lbl-andar">{t('signup:formFields.addressFloor')}:</label>
                                <label>{Props.customerInfo ? Props.customerInfo.addressFloor : '-'}</label>
                            </div>
                            <div className={classNames(['cell', 'small-6', 'adesao-subscricao-dados-esquerda'])}>
                                <label htmlFor="lbl-postal">{t('signup:formFields.postalCode')}:</label>
                                <label>{Props.customerInfo ? Props.customerInfo.postalCode : '-'}</label>
                            </div>
                            <div className={classNames(['cell', 'small-6', 'adesao-subscricao-dados-direita'])}>
                                <label htmlFor="lbl-localidade">{t('signup:formFields.city')}:</label>
                                <label>{Props.customerInfo ? Props.customerInfo.city : '-'}</label>
                            </div>
                            <div className={classNames(['cell', 'small-6', 'adesao-subscricao-dados-esquerda'])}>
                                <label htmlFor="lbl-nif">{t('signup:formFields.nif')}:</label>
                                <label>{Props.customerInfo ? Props.customerInfo.nif : '-'}</label>
                            </div>
                            <div className={classNames(['cell', 'small-6', 'adesao-subscricao-dados-direita'])}>
                                <label htmlFor="lbl-telefona">{t('signup:formFields.phoneNumber')}:</label>
                                <label>{Props.customerInfo ? Props.customerInfo.phoneNumber : '-'}</label>
                            </div>
                            <div className={classNames(['cell', 'small-12'])}>
                                <hr className={'sub-details-tw-1'} />
                                <p className={'sub-details-tw-3'}>
                                    {t(`subscriptions:createformNote1`)} <a className={'descricao-da-subscricao-perfil'} href={`${config.BaseURL}/profile`}>{t(`subscriptions:createformNote2`)}</a>
                                </p>
                            </div>
                        </div>

                    </div>
                    <div className={classNames(['cell', 'large-5', 'small-12'])}>
                        <div className={classNames(['grid-x', 'subscricao-tabela-subscricao'])}>
                            <div className={classNames(['cell', 'small-12'])}>
                                <span>
                                    {t('subscriptions:subDescription')}
                                </span>
                                <hr className={'sub-details-tw-1'} />
                            </div>
                            <div className={classNames(['cell', 'small-12'])}>
                                <label htmlFor="lbl-subscricao-valor">Valor da Subscrição</label>
                                <label>{`${plan && plan.plans && plan.plans[0].priceFormated}${t('subscriptions:euroByMonth')}`}</label>
                                <hr className={'sub-details-tw-1'} />
                            </div>
                            {isActivePlan && <React.Fragment>
                                <div className={classNames(['cell', 'small-12'])}>
                                    <label htmlFor="lbl-vin">{t('subscriptions:vin')}</label>
                                    <label>{userSubscription && userSubscription.vin && userSubscription.vin.toUpperCase()}</label>
                                    <hr className={'sub-details-tw-1'} />
                                </div>
                                <div className={classNames(['cell', 'small-12'])}>
                                    <label htmlFor="lbl-data-inicio">{t('subscriptions:nextBilling')}</label>
                                    <label>{userSubscription && userSubscription.nextBillingAt && Moment(userSubscription.nextBillingAt).format('DD/MM/YYYY')}</label>
                                    <hr className={'sub-details-tw-1'} />
                                </div>
                                <div className={classNames(['cell', 'small-12'])}>
                                    <label htmlFor="lbl-data-inicio">{t('subscriptions:fidelizationEnd')}</label>
                                    <label>
                                        {userSubscription && userSubscription.currentTermEnd && Moment(userSubscription.currentTermEnd).format('DD/MM/YYYY')}
                                        <div className={css.fidelizationNote}>{t('subscriptions:fidelizationEndNote')}</div>
                                    </label>
                                    <hr className={'sub-details-tw-1'} />
                                </div>

                                <div className={classNames(['cell', 'small-12'])}>
                                    <label htmlFor="lbl-estado">{t('subscriptions:status')}</label>
                                    <label>{userSubscription && t(`subscriptions:subscStatus.${SubscrStatusEnum[userSubscription.status]}`)}</label>
                                </div>
                                {vehicleHasActivePlan && userSubscriptionActivePlan && userSubscriptionActivePlan.status === SubscrStatusEnum.NonRenewing ?
                                    null :
                                    <button type="button" className={classNames(['button', 'expanded'])} onClick={() => handleOpenModal()} style={{ marginTop: '10px' }}>{t('subscriptions:cancelSub')}</button>
                                }
                            </React.Fragment>}
                            {!isActivePlan && vehicle && <React.Fragment>
                                <div className={classNames(['cell', 'small-12'])}>
                                    <label htmlFor="lbl-vin">{vehicle.vin ? t('subscriptions:vin') : t('subscriptions:plate')}</label>
                                    <label>{vehicle.vin ? vehicle.vin : vehicle.licensePlate}</label>
                                    <hr className={'sub-details-tw-1'} />
                                </div>
                                {!isOtherPlanActive && <React.Fragment>
                                    <div className={classNames(['cell', 'small-12'])}>
                                        <label htmlFor="lbl-data-inicio">{t('subscriptions:startDate')}</label>
                                        <label>{Moment(new Date()).format('DD/MM/YYYY')}</label>
                                        <hr className={'sub-details-tw-1'} />
                                    </div>
                                    <div className={classNames(['cell', 'small-12'])}>
                                        <label htmlFor="lbl-data-inicio">{t('subscriptions:status')}</label>
                                        <label>{t('subscriptions:subscStatus.New')}</label>
                                        <hr className={'sub-details-tw-1'} />
                                    </div>
                                </React.Fragment>}
                            </React.Fragment>}
                            <Modal
                                isOpen={state.isOpen}
                                onRequestClose={handleCloseModal}
                                onRequestConfirm={handleComfirmModal}
                                header={t(`subscriptions:cancelation.modal.header`)}
                                title={t(`subscriptions:cancelation.modal.title`)}
                                disclaimer={isActivePlan ? '' : t('subscriptions:confirmation.modal.disclaimer')}
                                items={getModalItems(plan)}
                                showReason={true}
                                reasonTitle={t(`subscriptions:cancelation.modal.reasonTitle`)}
                            />
                            {isActivePlan && <button type="button" className={classNames(['button', 'expanded'])} onClick={() => UpdatePaymentSource()}>{t('subscriptions:updatePayment')}</button>}
                        </div>
                    </div>

                    { /* {!isActivePlan && !isOtherPlanActive && <CreateForm planName={plan && plan.name} planId={routeMatch.params.planId} vehcode={state.vehcode} />} */ }
                    {isOtherPlanActive && <div className={cssMessages.infoMsg} >
                        <i className="fa fa-info-circle" style={{ marginRight: '5px' }} />
                        <b>
                            {t('subscriptions:inFidelizationPeriodMessage')}
                            <Link to={`${config.BaseURL}/subscription/details/${userSubscriptionActivePlan && userSubscriptionActivePlan.planBaseId}/${state.vehcode}`}>link</Link>
                        </b>
                    </div>}
                    {state.submitErrorText && <div className="error-message" style={{ float: 'right' }}>{state.submitErrorText}</div>}
                </React.Fragment>
                }

            </div>

            {!state.isLoading && (isDevMode || !invalidParams) && plan && !Props.isCommunicatingGetUserSubscriptions && <div className={css.boxAdjust}>

                <div className={css.availableServicesTitle}>
                    <div className={css.mainHeader}>
                        <h3 className={css.note}>{t('subscriptions:availableServices')}</h3>
                    </div>
                    {
                        Props.getSubscriptionItems && Props.getSubscriptionItems.map((subsc: SubscriptionItemDTO, idx: any) => {
                            if (!plan.availableServices || plan.availableServices.indexOf(subsc.code) < 0) {
                                return null;
                            }

                            const itemUsages = userSubscription && userSubscription.usages && userSubscription && userSubscription.usages.filter((x) => x.subscriptionItemCode === subsc.code).sort((a, b) => a.usageDate < b.usageDate ? -1 : a.usageDate > b.usageDate ? 1 : 0);
                            const usageDateByFrequencyAmount = itemUsages && itemUsages.length >= subsc.frequencyAmount && itemUsages[subsc.frequencyAmount - 1].usageDate;
                            const duration = usageDateByFrequencyAmount && Moment.duration(Moment(new Date()).diff(Moment(usageDateByFrequencyAmount)));
                            const nextUsageInMonths = duration ? duration.asMonths() : 0;
                            const nextUsableDate = usageDateByFrequencyAmount ? Moment(usageDateByFrequencyAmount).add(subsc.frequency, 'M').toDate() : new Date();
                            const renewDateMonthly = usageDateByFrequencyAmount ? new Date(nextUsableDate.getFullYear(), nextUsableDate.getMonth() + 1, 1) : new Date();

                            // plafond -------------
                            const totalPlafondYearly = subsc.hasPlafond && subsc.totalPlafondYearly;
                            const createdDate = totalPlafondYearly && userSubscription && userSubscription.createdAt ? userSubscription.createdAt : null;
                            const lastRenewDate = createdDate && new Date(createdDate);
                            if (lastRenewDate) {
                                for (lastRenewDate.setFullYear(lastRenewDate.getFullYear() + 1); lastRenewDate.getTime() < Date.now();) {
                                    lastRenewDate.setFullYear(lastRenewDate.getFullYear() + 1);
                                }
                                lastRenewDate.setFullYear(lastRenewDate.getFullYear() - 1);
                            }
                            const usedAmmount = lastRenewDate && itemUsages && itemUsages.filter((w) => lastRenewDate && new Date(w.usageDate).getTime() >= lastRenewDate.getTime()).map((z) => z.plafondConsumedAmount).reduce((a, b) => a + b, 0);
                            const description = `${subsc && subsc.description}<br />${subsc && subsc.description2 ? subsc.description2.replace('{0}', config.SubscrPlanitemsImagesPath).replace('{1}', config.SubscrPlanitemsImagesPath) : ''}`;

                            return (
                                <AccordionAvailableServices
                                    key={`accordion${idx}`}
                                    elem={
                                        <div key={`subitem${idx}`}>
                                            <img className={css.iconImg} src={config.SubscrPlanitemsImagesPath + subsc.icon} />
                                            {subsc.name}
                                        </div>}
                                    content={description ? description : ''}
                                    showCount={isActivePlan}
                                    readyToUse={nextUsageInMonths === 0 || nextUsageInMonths >= subsc.frequency}
                                    usableDate={renewDateMonthly}
                                    offerCode={subsc.offerCode}
                                    vehCode={state.vehcode}
                                    isActivePlan={isActivePlan}
                                    totalPlafondYearly={totalPlafondYearly ? totalPlafondYearly : 0}
                                    usedAmmount={usedAmmount ? usedAmmount : 0}
                                />
                            );
                        })
                    }
                </div>
                {isActivePlan && <div style={{ marginBottom: '100px' }}>
                    <div className={css.mainHeader}>
                        <h3 className={css.note}>{t('subscriptions:history')}</h3>
                    </div>
                    <CarHistory items={historyItems} />
                </div>}

            </div>}
        </React.Fragment>
    );
};

const mapStateToProps = (store: RootState) => ({
    getActivePlans: store.subscriptionState.getActivePlans.data,
    isCommunicatingGetActivePlans: store.subscriptionState.getActivePlans.isCommunicating,
    getSubscriptionItems: store.subscriptionState.getSubscriptionItems.data,
    isCommunicatingGetSubscriptionItems: store.subscriptionState.getSubscriptionItems.isCommunicating,
    getUserSubscriptions: store.subscriptionState.getUserSubscriptions.data,
    isCommunicatingGetUserSubscriptions: store.subscriptionState.getUserSubscriptions.isCommunicating,
    updatePaymentSource: store.subscriptionState.updatePaymentSource.data,
    isCommunicatingUpdatePaymentSource: store.subscriptionState.updatePaymentSource.isCommunicating,
    cancelSubscription: store.subscriptionState.cancelSubscription.data,
    isCommunicatingCancelSubscription: store.subscriptionState.cancelSubscription.isCommunicating,
    customerInfo: store.customerState.customerData.data.customerData,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    subscriptionActions: bindActionCreators(Actions, dispatch),
    subscriptionServiceActions: SubscriptionService.bindServiceActionCreators(config, dispatch),
    dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowDetails);
